export const buildIncomingSourceLookupKey = (
  sourceType: string,
  licensingCode: string,
  certificateNumber: string
): string => {
  const normalizedType = String(sourceType || "").trim().toUpperCase();
  const normalizedLicensingCode = String(licensingCode || "")
    .trim()
    .replace(/^CB-/i, "")
    .toUpperCase();
  const normalizedNumber = String(certificateNumber || "").trim().toUpperCase();

  return normalizedNumber
    ? [normalizedType, normalizedLicensingCode, normalizedNumber].join("|")
    : "";
};

type IncomingRawMaterialPayload = {
  tcProductCategoryCode?: string;
  tcProductDetailCode?: string;
  rawMaterialCode?: string;
  rawMaterialWeight?: number;
  tcProductIncomingCertifiedRawMaterialCode?: string;
  tcProductIncomingCertifiedRawMaterialWeightUsed?: number;
};

type IncomingNetWeightPayload = {
  tcProductIncomingArticleNo?: string;
  tcProductIncomingProductCategoryCode?: string;
  tcProductIncomingProductDetailCode?: string;
  tcProductIncomingRawMaterialInformation?: IncomingRawMaterialPayload[];
};

export const toCanonicalIncomingRawMaterialRows = (
  rows: IncomingRawMaterialPayload[]
): Array<{
  tcProductIncomingCertifiedRawMaterialCode: string;
  tcProductIncomingCertifiedRawMaterialWeightUsed: number;
}> =>
  rows.map((row) => ({
    tcProductIncomingCertifiedRawMaterialCode: String(
      row.tcProductIncomingCertifiedRawMaterialCode ?? row.rawMaterialCode ?? ""
    ).trim(),
    tcProductIncomingCertifiedRawMaterialWeightUsed: Number(
      row.tcProductIncomingCertifiedRawMaterialWeightUsed ?? row.rawMaterialWeight ?? 0
    ),
  }));

export const findInvalidIncomingRawMaterialArticles = (
  entries: IncomingNetWeightPayload[]
): string[] =>
  entries
    .filter((entry) => {
      const rows = Array.isArray(entry.tcProductIncomingRawMaterialInformation)
        ? entry.tcProductIncomingRawMaterialInformation
        : [];

      return (
        rows.length === 0 ||
        !String(entry.tcProductIncomingProductCategoryCode || "").trim() ||
        !String(entry.tcProductIncomingProductDetailCode || "").trim() ||
        rows.some((row) => {
          const weight = Number(
            row.tcProductIncomingCertifiedRawMaterialWeightUsed ?? row.rawMaterialWeight ?? 0
          );
          return (
            !String(
              row.tcProductIncomingCertifiedRawMaterialCode ?? row.rawMaterialCode ?? ""
            ).trim() ||
            !Number.isFinite(weight) ||
            weight <= 0
          );
        })
      );
    })
    .map((entry) => String(entry.tcProductIncomingArticleNo || "").trim())
    .filter(Boolean);
